var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from 'syf-component-library/ui/spacing';
import Body from 'syf-component-library/ui/typography/Body';
import { generateUUID } from 'syf-js-utilities';
import { FAQCollapseContainer } from './subcomponents';
var FAQDetails = function (_a) {
    var details = _a.details, isExpanded = _a.isExpanded;
    return (_jsx(FAQCollapseContainer, __assign({ id: "faq", className: "FAQs", expand: isExpanded }, { children: details.map(function (detail) {
            var faqUUID = generateUUID();
            return (_jsxs("div", { children: [_jsx(Body, { children: typeof detail === 'function' ? detail({ isExpanded: isExpanded }) : detail }), _jsx(Stack, { size: "large" })] }, "faq-detail-".concat(faqUUID)));
        }) })));
};
export default FAQDetails;
//# sourceMappingURL=FAQDetails.js.map